module.exports = __webpack_public_path__ + "img/terroir-3-mobile.07ec241e.jpg";